import React from "react";
/*
import GridOnIcon from '@material-ui/icons/GridOn';
*/

import {
    Code,
    FormatBold,
    FormatItalic,
    FormatListNumberedRtl,
    FormatQuote, FormatUnderlined, MenuBookRounded,
    PermMedia,
    TitleRounded,
    Toc, Videocam
} from "@mui/icons-material";
export const styleMap = {
    CODE: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
        fontSize: 16,
        padding: 2,
    },
    CENTER:{
        textAlign: "center",
        display: "block"
    },
    RIGHT:{
        textAlign: "right",
        display: "block"
    },
    LEFT:{
        textAlign: "left",
        display: "block"
    },
};

export function getBlockStyle(block) {
    switch (block.getType()) {
        case 'blockquote': return 'RichEditor-blockquote';
        default: return null;
    }
}

class StyleButton extends React.Component {
    constructor(props) {
        super(props);
        this.onToggle = (e) => {
            e.preventDefault();
            this.props.onToggle(this.props.style);
        };
    }

    render() {
        let className = 'RichEditor-styleButton';
        if (this.props.active) {
            className += ' RichEditor-activeButton';
        }

        return (
            <span className={className} onMouseDown={this.onToggle}>
              {this.props.label}
            </span>
        );
    }
}

const BLOCK_TYPES = [
    {label: <TitleRounded fontSize="large"/> , style: 'header-two',name: 'header-two'},
    {label: <TitleRounded />, style: 'header-three',name: 'header-three'},
    {label: <TitleRounded fontSize="small"/>, style: 'header-four',name: 'header-four'},
    {label: <FormatQuote/>, style: 'blockquote',name: 'blockquote'},
    {label: <Toc/>, style: 'unordered-list-item',name: 'unordered-list-item'},
    {label: <FormatListNumberedRtl/>, style: 'ordered-list-item',name: 'ordered-list-item'},
    {label: <Code/>, style: 'code-block',name: 'code-block'},
];

export const BlockStyleControls = (props) => {
    const {editorState} = props;
    const selection = editorState.getSelection();
    const blockType = editorState
        .getCurrentContent()
        .getBlockForKey(selection.getStartKey())
        .getType();

    return (
        <div className="RichEditor-controls">
            {BLOCK_TYPES.map((type) =>
                <StyleButton
                    key={type.name}
                    active={type.style === blockType}
                    label={type.label}
                    onToggle={props.onToggle}
                    style={type.style}
                />
            )}
        </div>
    );
};

const INLINE_STYLES = [
    {label: <FormatBold/> , style: 'BOLD',name: 'BOLD'},
    {label: <FormatItalic/>, style: 'ITALIC',name: 'ITALIC'},
    {label: <FormatUnderlined/>, style: 'UNDERLINE',name: 'UNDERLINE'},
];

export const InlineStyleControls = (props) => {
    let currentStyle = props.editorState.getCurrentInlineStyle();
    return (
        <div className="RichEditor-controls">
            {INLINE_STYLES.map(type =>
                <StyleButton
                    key={type.name}
                    active={currentStyle.has(type.style)}
                    label={type.label}
                    onToggle={props.onToggle}
                    style={type.style}
                />
            )}
            <PermMedia className = 'RichEditor-styleButton' onClick={props.onAddImage}/>
            <Videocam className = 'RichEditor-styleButton' onClick={props.onAddVideo}/>
            {
                !!props.blog &&
                <MenuBookRounded className = 'RichEditor-styleButton' onClick={props.onAddProduct}/>
            }


            {/*
            <GridOnIcon className = 'RichEditor-styleButton' onClick={props.onAddTable}/>
*/}
        </div>
    );
};